import { Fragment, useState } from "react";
import { Col, Form, Input, Label, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import { Direction } from "reactstrap/types/lib/Offcanvas";
import { Btn, H4, H5, P } from "../../../../AbstractElements";
import { TopBottomOffcanvasType } from "../../../../Types/UiKitsType";

const LeftRightOffcanvas:React.FC<TopBottomOffcanvasType> = ({title,direction,color,data}) => {
  const [show, setShow] = useState(false);
  const toggle = () => setShow(!show);
  return (
    <Fragment>
      <Btn color={color} onClick={toggle}>{title}</Btn>
      <Offcanvas scrollable className="offcanvasTop" toggle={toggle} isOpen={show} direction={direction as Direction}>
        <OffcanvasHeader toggle={toggle}>
          <H4 className="offcanvas-title">{title}</H4>
        </OffcanvasHeader>
        <OffcanvasBody className="custom-scrollbar">
          {data&&
            <Fragment>
               <H5>Wed designer</H5>
               <P>For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience.</P>
            </Fragment>
          }
          <Form className="row g-3">
            <Col xs="12">
              <Label>Email</Label>
              <Input type="email" placeholder="name@example.com" required/>
            </Col>
            <Col xs="12">
              <Label>Select Project</Label>
              <Input type="select" required>
                <option selected disabled>Select your projects</option>
                <option>Project1 </option>
                <option>Project2 </option>
                <option>Project3</option>
              </Input>
            </Col>
            <Col xs="12">
              <Label>Project Counts</Label>
              <Input type="select" required>
                <option selected disabled>How many projects do you make?</option>
                <option>One </option>
                <option>Two </option>
                <option>Three</option>
              </Input>
            </Col>
            <Col xs="12"> 
              <Label>External Notes</Label>
              <Input type="textarea" rows="4"></Input>
            </Col>
            <Col xs="12">
              <div className="form-check checkbox-checked">
                <Label check><Input type="checkbox" required />Agree to terms and conditions</Label>
              </div>
            </Col>
            <Col xs="12">
              <Btn color="light" className="me-2" onClick={toggle}>Cancel</Btn>
              <Btn color="primary">Submit</Btn>
            </Col>
          </Form>
        </OffcanvasBody>
      </Offcanvas>
    </Fragment>
  );
};

export default LeftRightOffcanvas;
